import { useMemo, useState } from 'react';
import { usePatientStore } from '@store/patientStore';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { OnlineBookingToast } from '@common/OnlineBookingToast';

export const ReschedulingBanner = () => {
  const [open, setOpen] = useState(true);

  const patients = usePatientStore(state => state.patients);
  const currentPatientIndex = useOnlineBookingStore(
    state => state.currentPatient,
  );
  const isRescheduling = useOnlineBookingStore(state => state.isRescheduling);
  const failedPatients: Array<string | undefined> = useMemo(() => {
    return patients
      .map((patient, index) => {
        if (
          patient &&
          patient.appointmentId === undefined &&
          index !== currentPatientIndex // il current va in cima
        ) {
          return `${patient?.patientDetails?.firstName} ${patient?.patientDetails?.lastName}`;
        }
        return undefined;
      })
      .filter(s => s);
  }, [patients, currentPatientIndex]);

  const title = useMemo(() => {
    return `Please select a new appointment for ${patients[currentPatientIndex]?.patientDetails?.firstName} ${patients[currentPatientIndex]?.patientDetails?.lastName}`;
  }, [currentPatientIndex, patients]);

  const description = useMemo(() => {
    return failedPatients.length > 0
      ? `You also have the option to reschedule the appointment for: ${failedPatients.join(',')}`
      : undefined;
  }, [failedPatients]);

  return (
    <OnlineBookingToast
      open={!!isRescheduling && open}
      onClose={() => setOpen(false)}
      title={title}
      description={description}
    />
  );
};
